import React, { useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import classNames from "classnames";
import "./index.scss";

import { actionResetTooltipData, actionUpdateTooltipData } from "../../../store/reducers/tooltipPortal/tooltipPortal-actions";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";

const SectionItemLink = ({ history, column, item, model, updateTooltipData, resetTooltipData }) => {
  const { accessor, title, link, iconName, tooltipText, isReadonly } = column;
  const ref = useRef();

  const handleOnClick = () => {
    if(isReadonly){
      return;
    }

    history.push(`${link}?id=${item[model.key]}`)
  }

  return (
    <div key={`propItem-${accessor}`} className={classNames("sectionItemLink")}
      onMouseEnter={()=> !!tooltipText && updateTooltipData({ tooltipText, ref: ref.current })} 
      onMouseLeave={()=> !!tooltipText && resetTooltipData()}
    >
      {title && (
          <ColumnTitleWithIcon column={column} item={item}/>
      )}
      <div ref={ref} className={classNames(iconName || "")} 
        onClick={handleOnClick} 
      />
    </div>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    updateTooltipData: data => dispatch(actionUpdateTooltipData(data)),
    resetTooltipData: ()=> dispatch(actionResetTooltipData())
  };
};

export default withRouter(connect(null, mapDispatchToProps)(SectionItemLink));
